import type { RouteRecordRaw } from "vue-router";

export const linkShortenerRoutes: RouteRecordRaw[] = [
  {
    path: "/link_shortener/info",
    name: "link_shortener-info",
    component: () => import("./info.vue"),
    meta: {
      title: "tools_meta.link_shortener_prefix",
    },
  },
  {
    path: "/link_shortener/links",
    name: "link_shortener-index",
    component: () => import("./links/ShortLinkListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "link_shortener",
      title: "tools_meta.link_shortener_prefix",
    },
  },
  {
    path: "/link_shortener/links/:id",
    name: "link_shortener-show",
    component: () => import("./links/ShortLinkLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "link_shortener",
      title: "tools_meta.link_shortener_prefix",
    },
    children: [
      {
        path: "settings",
        name: "link_shortener-settings",
        component: () => import("./links/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "link_shortener",
          title: "tools_meta.link_shortener_prefix",
        },
      },
      {
        path: "share",
        name: "link_shortener-share",
        component: () => import("./links/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "link_shortener",
          title: "tools_meta.link_shortener_prefix",
        },
      },
    ],
  },
  {
    path: "/link_shortener/public_links/:id",
    name: "link_shortener-public-links",
    component: () => import("./public_links/PublicShortLinkPage.vue"),
    meta: {
      title: "tools_meta.link_shortener_prefix",
    },
  },
];
